import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "operation-bar"
};
const _hoisted_2 = {
  class: "statistics-bar"
};
const _hoisted_3 = {
  class: "statistics-item"
};
const _hoisted_4 = {
  class: "statistics-value"
};
const _hoisted_5 = {
  class: "table-wrap"
};
const _hoisted_6 = {
  class: "el-pagination-wrap"
};
const _hoisted_7 = {
  class: "dialog-footer"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
import { ref, reactive, onMounted, watch } from 'vue';
import { ElMessage } from "element-plus";
import { Search } from '@element-plus/icons-vue';
import dayjs from "dayjs";
import apis from "@/api";
import { accrueLedgerTotalAmount } from "@/api/modules/advert";
export default {
  __name: 'AccrueLedger',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userRole: {
      type: Object,
      default: () => ({
        areaCode: '-1',
        isAdmin: false,
        isSupplier: false
      })
    }
  },
  emits: ['update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const close = () => {
      emit('update:visible', false);
    };

    // 搜索参数
    const queryParam = reactive({
      monthStart: dayjs().startOf('year').format("YYYY-MM"),
      // 今年的第一个月份起始
      monthEnd: dayjs().endOf('year').format("YYYY-MM"),
      // 今年的最后一个月份结束
      contractCode: '',
      // 合同编码
      contractName: '',
      // 合同名称
      supplier: '',
      // 供应商
      budgetCode: '',
      // 预算项目
      mainClass: '',
      // 业务大类
      subClass: '',
      // 业务小类
      businessActive: '',
      // 业务活动
      orderCode: '' // 费用订单编号  
    });

    // 表格数据
    const tableData = ref([]);
    const loading = ref(false);

    // 分页参数
    const pagination = reactive({
      pageNo: 1,
      pageSize: 10,
      totalSize: 0
    });

    // 统计数据
    const statistics = reactive({
      budgetAmount: '0.00' // 预算金额统计
    });

    // 导入对话框
    const importDialog = reactive({
      visible: false,
      month: '',
      // 选择年月
      fileList: [],
      uploading: false
    });

    // 导出对话框
    const exportDialog = reactive({
      visible: false,
      monthStart: '',
      // 起始年月
      monthEnd: '' // 结束年月
    });

    // 加载数据
    const loadData = () => {
      var _props$userRole;
      loading.value = true;
      const params = {
        ...queryParam,
        pageNo: pagination.pageNo,
        pageSize: pagination.pageSize,
        areaCode: ((_props$userRole = props.userRole) === null || _props$userRole === void 0 ? void 0 : _props$userRole.areaCode) || ''
      };

      // 调用API查询台账列表
      apis.accrueLedgerList(params).then(response => {
        if (response.success) {
          tableData.value = response.data.records || [];
          pagination.totalSize = response.data.total || 0;
          // 查询统计
          apis.accrueLedgerTotalAmount(params).then(response => {
            if (response.success) {
              statistics.budgetAmount = formatAmount(response.data);
            } else {
              statistics.budgetAmount = '0.00';
              ElMessage.error(response.msg || '查询失败');
            }
          });
        } else {
          ElMessage.error(response.msg || '查询失败');
          tableData.value = [];
          pagination.totalSize = 0;
        }
      }).catch(error => {
        console.error('查询数据失败:', error);
        ElMessage.error('查询数据失败');
        tableData.value = [];
        pagination.totalSize = 0;
      }).finally(() => {
        loading.value = false;
      });
    };

    // 格式化金额
    const formatAmount = amount => {
      if (amount === null || amount === undefined || amount === '') return '0.00';
      return parseFloat(amount).toFixed(2);
    };

    // 格式化日期
    const formatDate = date => {
      if (!date) return '';
      return dayjs(date).format('YYYY-MM-DD');
    };

    // 查询
    const handleSearch = () => {
      pagination.pageNo = 1;
      loadData();
    };

    // 重置
    const handleReset = () => {
      queryParam.monthStart = '';
      queryParam.monthEnd = '';
      queryParam.contractCode = '';
      queryParam.contractName = '';
      queryParam.supplier = '';
      queryParam.budgetCode = '';
      queryParam.mainClass = '';
      queryParam.subClass = '';
      queryParam.businessActive = '';
      queryParam.orderCode = '';
      handleSearch();
    };

    // 分页大小变化
    const handleSizeChange = val => {
      pagination.pageSize = val;
      pagination.pageNo = 1;
      loadData();
    };

    // 当前页变化
    const handleCurrentChange = val => {
      pagination.pageNo = val;
      loadData();
    };

    // 打开导入对话框
    const handleImport = () => {
      importDialog.visible = true;
      importDialog.month = '';
      importDialog.fileList = [];
      importDialog.uploading = false;
    };

    // 关闭导入对话框
    const closeImportDialog = () => {
      importDialog.visible = false;
      importDialog.month = '';
      importDialog.fileList = [];
      importDialog.uploading = false;
    };

    // 处理文件选择
    const handleFileChange = file => {
      importDialog.fileList = [file];
    };

    // 处理文件移除
    const handleFileRemove = () => {
      importDialog.fileList = [];
    };

    // 执行导入
    const handleImportConfirm = () => {
      var _props$userRole2;
      if (!importDialog.month) {
        ElMessage.warning('请选择年月');
        return;
      }
      if (importDialog.fileList.length === 0) {
        ElMessage.warning('请选择文件');
        return;
      }
      importDialog.uploading = true;

      // 调用导入接口
      const formData = new FormData();
      formData.append('month', importDialog.month);
      formData.append('file', importDialog.fileList[0].raw);
      formData.append('areaCode', ((_props$userRole2 = props.userRole) === null || _props$userRole2 === void 0 ? void 0 : _props$userRole2.areaCode) || '');
      apis.importAccrueLedger(formData).then(res => {
        if (res.success) {
          ElMessage.success('导入成功');
          closeImportDialog();
          loadData();
        } else {
          ElMessage.error(res.msg || '导入失败');
        }
      }).catch(error => {
        console.error('导入失败:', error);
        ElMessage.error('导入失败');
      }).finally(() => {
        importDialog.uploading = false;
      });
    };

    // 打开导出对话框
    const handleExport = () => {
      exportDialog.visible = true;
      exportDialog.monthStart = queryParam.monthStart || '';
      exportDialog.monthEnd = queryParam.monthEnd || '';
    };

    // 关闭导出对话框
    const closeExportDialog = () => {
      exportDialog.visible = false;
      exportDialog.monthStart = '';
      exportDialog.monthEnd = '';
    };

    // 执行导出
    const handleExportConfirm = () => {
      var _props$userRole3;
      if (!exportDialog.monthStart || !exportDialog.monthEnd) {
        ElMessage.warning('请选择起末年月');
        return;
      }
      const params = {
        monthStart: exportDialog.monthStart,
        monthEnd: exportDialog.monthEnd,
        areaCode: ((_props$userRole3 = props.userRole) === null || _props$userRole3 === void 0 ? void 0 : _props$userRole3.areaCode) || ''
      };
      apis.exportAccrueLedger(params).then(res => {
        // 处理导出文件下载
        if (res && res instanceof Blob) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', `计提台账_${exportDialog.monthStart}_${exportDialog.monthEnd}.xlsx`);
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);
          ElMessage.success('导出成功');
          closeExportDialog();
        } else if (res && res.success === false) {
          ElMessage.error(res.msg || '导出失败');
        } else {
          ElMessage.error('导出失败');
        }
      }).catch(error => {
        console.error('导出失败:', error);
        ElMessage.error('导出失败');
      });
    };

    // 监听 visible 变化，重新加载数据
    watch(() => props.visible, newVal => {
      if (newVal) {
        handleSearch();
      }
    });

    // 初始化时加载数据
    onMounted(() => {
      if (props.visible) {
        handleSearch();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "计提台账",
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        fullscreen: "",
        "append-to-body": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true,
          class: "filter-form"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "月份起始"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: queryParam.monthStart,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryParam.monthStart = $event),
              type: "month",
              "value-format": "YYYY-MM",
              format: "YYYY-MM",
              placeholder: "请选择年月",
              style: {
                "width": "180px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "月份结束"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: queryParam.monthEnd,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryParam.monthEnd = $event),
              type: "month",
              "value-format": "YYYY-MM",
              format: "YYYY-MM",
              placeholder: "请选择年月",
              style: {
                "width": "180px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "合同编码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParam.contractCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParam.contractCode = $event),
              placeholder: "请输入合同编码",
              style: {
                "width": "180px"
              },
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "合同明细"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParam.contractName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => queryParam.contractName = $event),
              placeholder: "请输入合同名称",
              style: {
                "width": "180px"
              },
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "供应商"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParam.supplier,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => queryParam.supplier = $event),
              placeholder: "请输入供应商",
              style: {
                "width": "180px"
              },
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "预算项目"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParam.budgetCode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => queryParam.budgetCode = $event),
              placeholder: "请输入预算编码",
              style: {
                "width": "180px"
              },
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "业务大类"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParam.mainClass,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => queryParam.mainClass = $event),
              placeholder: "请输入业务大类",
              style: {
                "width": "180px"
              },
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "业务小类"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParam.subClass,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => queryParam.subClass = $event),
              placeholder: "请输入业务小类",
              style: {
                "width": "180px"
              },
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "业务活动"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParam.businessActive,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => queryParam.businessActive = $event),
              placeholder: "请输入业务活动",
              style: {
                "width": "180px"
              },
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "费用订单编号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParam.orderCode,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => queryParam.orderCode = $event),
              placeholder: "请输入费用订单编号",
              style: {
                "width": "180px"
              },
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: _unref(Search),
              plain: "",
              onClick: handleSearch
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("查询", -1)]))]),
              _: 1
            }, 8, ["icon"]), _createVNode(_component_el_button, {
              onClick: handleReset,
              style: {
                "margin-left": "5px"
              }
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("重置", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: handleImport
        }, {
          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("导入台账", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: handleExport
        }, {
          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("导出台账", -1)]))]),
          _: 1
        })]), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, [_cache[20] || (_cache[20] = _createElementVNode("span", {
          class: "statistics-label"
        }, "报账金额合计：", -1)), _createElementVNode("span", _hoisted_4, _toDisplayString(statistics.budgetAmount), 1)])]), _createElementVNode("div", _hoisted_5, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          style: {
            "width": "100%"
          },
          height: "calc(100vh - 430px)",
          border: "",
          "header-cell-style": {
            background: '#ECF5FF'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "month",
            label: "计提年月",
            width: "100",
            fixed: "left"
          }), _createVNode(_component_el_table_column, {
            prop: "rowNum",
            label: "行号",
            width: "80"
          }), _createVNode(_component_el_table_column, {
            prop: "supplier",
            label: "供应商",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "contractCode",
            label: "合同",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "contractDetail",
            label: "合同明细",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "mainClass",
            label: "业务大类",
            width: "120"
          }), _createVNode(_component_el_table_column, {
            prop: "subClass",
            label: "业务小类",
            width: "120"
          }), _createVNode(_component_el_table_column, {
            prop: "businessActive",
            label: "业务活动",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "ledgerDate",
            label: "预算日期",
            width: "120"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(formatDate(scope.row.ledgerDate)), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "ledgerProject",
            label: "预算项目",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "costCenter",
            label: "成本中心",
            width: "120"
          }), _createVNode(_component_el_table_column, {
            prop: "accrueAmount",
            label: "报账金额",
            width: "120",
            align: "right"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(formatAmount(scope.row.accrueAmount)), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "orderCode",
            label: "费用订单编号",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "summary",
            label: "摘要",
            width: "200",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "accrueYear",
            label: "合同预算年度",
            width: "120"
          }), _createVNode(_component_el_table_column, {
            prop: "marketData",
            label: "市场-主数据",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "productData",
            label: "产品-主数据",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "remark",
            label: "备注",
            width: "200",
            "show-overflow-tooltip": ""
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_pagination, {
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          "page-sizes": [10, 20, 50, 100],
          "page-size": pagination.pageSize,
          total: pagination.totalSize,
          "current-page": pagination.pageNo,
          "onUpdate:currentPage": _cache[10] || (_cache[10] = $event => pagination.pageNo = $event),
          layout: "total, prev, pager, next, sizes, jumper"
        }, null, 8, ["page-size", "total", "current-page"])]), _createVNode(_component_el_dialog, {
          modelValue: importDialog.visible,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => importDialog.visible = $event),
          title: "导入台账",
          width: "500px",
          "append-to-body": ""
        }, {
          footer: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_button, {
            onClick: closeImportDialog
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("取消", -1)]))]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleImportConfirm,
            loading: importDialog.uploading
          }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("确定", -1)]))]),
            _: 1
          }, 8, ["loading"])])]),
          default: _withCtx(() => [_createVNode(_component_el_form, {
            model: importDialog,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "选择年月",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: importDialog.month,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => importDialog.month = $event),
                type: "month",
                "value-format": "YYYY-MM",
                format: "YYYY-MM",
                placeholder: "请选择年月",
                style: {
                  "width": "100%"
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "选择文件",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_upload, {
                "file-list": importDialog.fileList,
                "auto-upload": false,
                limit: 1,
                "on-change": handleFileChange,
                "on-remove": handleFileRemove
              }, {
                tip: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createElementVNode("div", {
                  class: "el-upload__tip"
                }, "请选择Excel文件", -1)]))]),
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  type: "primary"
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("选取文件", -1)]))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["file-list"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: exportDialog.visible,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => exportDialog.visible = $event),
          title: "导出台账",
          width: "500px",
          "append-to-body": ""
        }, {
          footer: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_button, {
            onClick: closeExportDialog
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode("取消", -1)]))]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleExportConfirm
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode("确定", -1)]))]),
            _: 1
          })])]),
          default: _withCtx(() => [_createVNode(_component_el_form, {
            model: exportDialog,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "起始年月",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: exportDialog.monthStart,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => exportDialog.monthStart = $event),
                type: "month",
                "value-format": "YYYY-MM",
                format: "YYYY-MM",
                placeholder: "请选择起始年月",
                style: {
                  "width": "100%"
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "结束年月",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: exportDialog.monthEnd,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => exportDialog.monthEnd = $event),
                type: "month",
                "value-format": "YYYY-MM",
                format: "YYYY-MM",
                placeholder: "请选择结束年月",
                style: {
                  "width": "100%"
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};